import { useState } from 'react'
import { supabase } from '../supabaseClient'
import { useAuth } from '../context/AuthContext'

export default function LogoUpload({ onUploaded }) {
  const { profile } = useAuth()
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')

  async function handleUpload(e) {
    const file = e.target.files[0]
    if (!file) return
    if (!['image/png', 'image/jpeg'].includes(file.type)) {
      setError('Please upload a PNG or JPG file')
      return
    }

    setUploading(true)
    setError('')

    const ext = file.name.split('.').pop()
    const filename = 'logo-' + profile.clinic_id + '.' + ext

    const { error: uploadError } = await supabase.storage
      .from('exercises')
      .upload(filename, file, { upsert: true })

    if (uploadError) { setError(uploadError.message); setUploading(false); return }

    const { data: urlData } = supabase.storage.from('exercises').getPublicUrl(filename)

    const { error: updateError } = await supabase
      .from('clinics')
      .update({ logo_url: urlData.publicUrl })
      .eq('id', profile.clinic_id)

    if (updateError) { setError(updateError.message); setUploading(false); return }

    setUploading(false)
    if (onUploaded) onUploaded(urlData.publicUrl)
  }

  async function handleRemove() {
    await supabase.from('clinics').update({ logo_url: null }).eq('id', profile.clinic_id)
    if (onUploaded) onUploaded(null)
  }

  return (
    <div>
      {error && <p style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 8 }}>{error}</p>}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <label style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          background: 'var(--surface)', border: '1.5px solid var(--border)',
          borderRadius: 8, padding: '7px 14px', fontSize: 13, fontWeight: 500,
          cursor: 'pointer', color: 'var(--text-primary)'
        }}>
          {uploading ? 'Uploading...' : '📷 Upload logo'}
          <input type="file" accept="image/png,image/jpeg" onChange={handleUpload} style={{ display: 'none' }} disabled={uploading} />
        </label>
        {profile?.clinics?.logo_url && (
          <button type="button" className="danger" onClick={handleRemove} style={{ fontSize: 12, padding: '6px 10px' }}>
            Remove
          </button>
        )}
      </div>
      <p style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 6 }}>PNG or JPG, recommended height 40px</p>
    </div>
  )
}